<template>
  <!-- 创建积分优惠券 -->
  <div class="create_coupons" v-if="isShow">
    <div class="backBox">
      <img class="pointer" @click="retrunMethod()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <template v-if="activityData && activityData.name">
        <span class="backBox_name">{{ activityData.name }}</span>
      </template>
      <template v-else>
        <span class="txt"  @change="changeTab(tabActive)">积分兑换红包</span>
      </template>
    </div>

    <div :class="{ formBox: localStep != 0 }">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <div class="firststep" v-if="localStep == 0">
        <!-- <div class="tishi"> -->
        <!--  -->
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid rgba(123,97,255,0.15);">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: rgba(123, 97, 255, 0.05);"></div>
              </div>
               <!-- hover -->
               <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img style="width:100%;max-height: 380px;" :src="item.templateUrl" alt="" />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div>
                <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="localStep == 1">
        <!-- 兑换表单 -->
        <main class="main">
          <el-form :model="form" :rules="rules" ref="form" label-width="160px">
            <el-form-item label="礼品名称:" required>
              <el-input v-model="form.activityName" maxlength="15" show-word-limit placeholder="请填入活动名称" style="width: 320px"></el-input>
            </el-form-item>
						
            <el-form-item label="上下架时间:" required>
              <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.startTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 135px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValue"
                  :clearable="false"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime">
                活动持续
                <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
                <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color:#ccc"></i>
                  </el-button>
                </el-tooltip>
                <!-- <span style="color: #7B61FF;">23</span> 小时  -->
              </span>
            </el-form-item>

            <el-form-item label="礼品图片:" required>
              <div></div>
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :http-request="httpRequest"
                :file-list="fileList"
              >
                <!-- <img v-if="form.logo" :src="form.logo" style="width: 146px; height: 146px" />
              <i class="el-icon-plus" v-else></i> -->
                <i class="el-icon-plus"></i>
              </el-upload>
              <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog> -->
              <span style="color: red; font-size: 14px">建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span>
            </el-form-item>
            <!-- 活动对象 -->
            <information
              ref="information" 
              v-model="ruleDTO" 
            />

            <el-form-item label="兑换次数限制:" required>
							<div>
								<span> 每人每日兑换次数：</span>
								<el-input v-model="form.exchangeDayTimes" placeholder="请输入" @input="form.exchangeDayTimes = getNumberData(1, $event, 0, 1,20)" style="width: 136px;margin:0 5px;"></el-input>
								<el-tooltip class="item" effect="light" content="每人每日兑换次数需≤20次，且不可超过每人活动内兑换次数设置数" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color:#ccc"></i>
                  </el-button>
                </el-tooltip>
							</div>
							<div style="margin-top: 20px;">
								<span> 每人活动内兑换次数：</span>
								<el-input v-model="form.exchangeTimes" placeholder="请输入" @input="form.exchangeTimes = getNumberData(1, $event, 0, 1,20)" style="width: 136px;margin:0 5px;"></el-input>
								<el-tooltip class="item" effect="light" content="每人活动内兑换次数需≤20次" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color:#ccc"></i>
                  </el-button>
                </el-tooltip>
							</div>
            </el-form-item>

						<el-form-item label="红包份数限制:" required>
							<el-tooltip class="item" effect="light" content="每人每天兑换红包的份数设置，每天累计领取红包金额不超过10000元，单次可领取红包面额最大为4999元。" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color:#ccc"></i>
                  </el-button>
              </el-tooltip>
							<div>
								<span> 每人每日兑换份数：</span>
								<el-input v-model="form.exchangeDayNum" placeholder="请输入" @input="form.exchangeDayNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
							</div>
							<div style="margin-top: 20px;">
								<span> 每人活动内兑换份数：</span>
								<el-input v-model="form.exchangeNum" placeholder="请输入" @input="form.exchangeNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
							</div>
            </el-form-item>

						<el-form-item label="红包有效期:" required>
              <el-radio-group v-model="form.redPacketExpiration">
                <el-radio :label="2">相对时间</el-radio>
                <el-radio :label="1">绝对时间</el-radio>
              </el-radio-group>
              <div v-if="form.redPacketExpiration == 2">
                领取后 <el-input v-model="form.effectiveDays"  style="width: 136px" @input="form.effectiveDays = getNumberData(1, $event, 1)"></el-input
              > 天内有效
              </div>
              <div v-if="form.redPacketExpiration == 1">
                <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.startTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 135px; font-size: 12px"
                  class="time1"
                  :picker-options="pickerOptionsValue"
                  @change="activityTimeChange2"
                  :clearable="false"
                  :disabled="true"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.effectiveEndTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  @change="activityTimeChange2"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTime2()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              </div>
            </el-form-item>

            <!-- redPrice -->
						<el-form-item label="单份红包金额:" required>
              <el-input v-model="form.redPrice"   
              @input="form.redPrice = getNumberData(1, $event, 1, 1,4999)"  
              @change="inputNum"
              style="width: 136px"></el-input
              >元
							<el-tooltip class="item" effect="light" content="单份红包设置：最大份额4999元，最小面额：1元" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question" style="color:#ccc"></i>
                  </el-button>
              </el-tooltip>
            </el-form-item>


            <el-form-item label="发行总量:" required>
              <el-input v-model="form.quantityTotal" @input="form.quantityTotal = getNumberData(1, $event, 0, 1)"  style="width: 136px"></el-input
              >份
            </el-form-item>

						<el-form-item label="预计所需红包总量:">
							<div>
								<span style="color:red;font-size:14px;" >{{form.redPrice?form.redPrice*form.quantityTotal:0}}</span>元
								<span style="margin-left: 10px;">当前红包账号余额：</span><span style="color:red;font-size:14px;">{{quantityBalance}}</span>元可使用
								<span style="margin-left: 10px;color: #7b61ff;cursor: pointer;" @click="allSearch">刷新</span>
								<span style="margin-left: 10px;cursor: pointer;color: #7b61ff;" @click="jumpRC">去充值</span>
							</div>
							<div style="color:red;font-size:14px;">注意：活动发放总量不能大于账户剩余量，礼品发放数到达总量后，兑换活动自动结束</div>
            </el-form-item>

            <el-form-item label="兑换所需等级:" required>
              <div class="level-wrap">
                <el-checkbox-group v-model="memberLe" @change="checkListchange">
                  <el-checkbox :label="memberLe">全部</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group
                  v-model="level"
                  v-for="(item, index) in memberLevelList"
                  :key="index"
                  @change="checkTheChange"
                >
                  <el-checkbox :label="item.value" :disabled="memberLe == true" v-if="item.label">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item label="兑换所需积分:" required>
              <div class="isLevelSet" style="width: 600px">
                <template v-if="!isLevelSet">
                  <el-input v-model.number="form.memberLevelPoints" @input="form.memberLevelPoints = getNumberData(1, $event, 0, 1),upodata()" style="width: 136px;"></el-input>
                  积分=1红包
                </template>
                <template v-else>
                  <ul class="levelList">
                    <li class="item"  v-for="item in memberLevelList" :key="item.value">
                      {{ item.label }}
                      <el-input
                        v-model.number="item.point"
                        placeholder="请输入..."
                        @input="item.point = getNumberData(1, $event, 0, 1)"
                        style="width: 80px"
                      ></el-input>
                      积分=1红包
                    </li>
                  </ul>
                </template>
                <button class="setBtn" @click.prevent="isLevel">
                  {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
                </button>
              </div>
            </el-form-item>

            <el-form-item label="规则说明:" required>
              <div
                style="
                width: 720px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding-top: 8px;
              "
              >
                <el-input type="textarea" class="textarea" style="width: 704px" resize="none" :rows="6" v-model="form.ruleDescription"></el-input>

                <div style="margintop: 8px">
                  <el-button type="primary" class="generate" plain @click="generativerule">生成规则</el-button>
                  <span class="txt">点击按钮自动生成规则，也可以自己编辑信息</span>
                </div>
              </div>
            </el-form-item>
            <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          </el-form>
        </main>

        <!-- 底部按钮 -->
        <!-- <footer class="foot">
        <button class="backBtn" @click="retrunMethod()">返回上一页</button>
        <button class="keepBtn" @click="setActivity" v-preventReClick>
          保存并完成设置
        </button>
      </footer> -->

        <!-- 添加优惠券 -->
        <add-coupon :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>

        <!-- 自营=====添加优惠券 -->
        <self-support-addCoupon
          :isShow="selfSupportAddCouponIsShow"
          @close="selfSupportAddCouponIsShow = false"
          @funcMes="addStatusCoupon"
        ></self-support-addCoupon>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button class="returnBtn" @click="retrunMethod()">返回上一页</el-button>
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <el-button class="keepBtn" @click="setActivity" v-preventReClick>
        保存并完成设置
      </el-button>
    </div>
    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <input-form style="margin: 20px 0" :inputData="commodityList" @toParentVal="searchContent"></input-form>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
            <!-- <span>{{ scope.row.skuName }}</span
            ><br />
            <span>¥{{ scope.row.jdPrice }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="chooseShop(scope.row)" style="width: 50px">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="5"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalList"
      ></el-pagination>
    </el-dialog>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" v-if="showSetDialog" :visible.sync="showSetDialog" width="800" @close="showSetDialog = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetDialog = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addCoupon from "./add_coupon";
import selfSupportAddCoupon from "./selfSupport_add_coupon"; //自营
import inputForm from "../../components/inputForm";
import { querydetail, closeSellerCouponWrite } from "@/api/integralCenter/couponWriteController.js";
import QRCode from "qrcodejs2";
import { getTaobaoItemListSku, getSellercats } from "@/api/analysis/ware-controller.js";

import {
  uploadpic,
  accountBalance,
  createRedPacket,
  inquireActivity
} from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import { mapState } from "vuex";
import {
  allAccount,
} from "@/api/integralCenter/prizeCenter.js";
import information from '@/views/integralCenter/components/information.vue';

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 29,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    addCoupon,
    inputForm,
    selfSupportAddCoupon,
    information,
  },
  computed: {
    ...mapState(["venderType"]),
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || (this.activityData&&this.activityData.singleCopy);
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
          this.allSearch();
        });
      }
    },
  },
  data() {
    return {
      ruleDTO: {
        condFollow: 0,
        activityTargetType: '2', // 固定值
        allowLevel: "-1",
        plusObject: 0,
        crowdIds: "",
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        orderCompleteLimitCount: "",
        orderCompleteMaxCount: "",
        orderCompleteLimitPayment: "",
        orderCompleteMaxPayment: "",
        lastOrderCompleteTimeType: 0,
        lastOrderCompleteStartDay: "",
        lastOrderCompleteEndDay: "",
        lastOrderCompleteStartTime: "",
        lastOrderCompleteEndTime: "",
        isCheckOpenCardTime: "",
        openCardStartTime: "",
        openCardEndTime: "",
      },
      isKeyActivity: 0,
      placementPosition: [],
      showSetDialog: false,
      checked: false, //  是否明确活动规则 保存后弹窗内的勾选框
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      localStep: this.stepNum,
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
        },
      },
      fileList: [],
      memberLevelPointsDTOList: [
        // {
        //   level:1,
        //   allow:true,
        //   point:10
        // }
      ],
      butActive: 1,
      commodityList: [
        // {
        //   name: "商品类目:",
        //   val: "categoryId",
        //   selectArr: [],
        //   width: 240,
        // },
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      // 表单值
      form: {
        logo: "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E4%BA%AC%E8%B1%86.png",
        activityName: "",
        ruleDescription: "",
        price: null,
        redPrice:null,
        exchangeTimes: null,
        quantityTotal: null,
        exchangeDayTimes:'',
        exchangeTimes:'',
        redPacketExpiration:2,
        effectiveDays:'',
        effectiveStartTime:  this.$getDate(30)[0],
        effectiveEndTime:'',
        assetsId: null,
        startTime: null,
        endTime: null,
        memberLevelPoints: "",
        couponRedemptionType: "",
        exchangeDayNum: "",
        exchangeNum: "",
        frequencyType: 1, // 次数限制  后端不需要的参数，前端自定义
        limitVal: "", //后端不需要的参数，前端自定义 frequencyType（0传form.exchangeDayTimes）frequencyType（1传form.exchangeTimes）
        exchangeSet: [
          // 套餐： json数组 [{"id":1,"singleNum":5,"total":10,"actual":0}] id，套餐id，singleNum单份数量，total套餐数量，actual已兑换套餐数量
          {
            singleNum: null,
            total: null,
          },
        ],
      },
      level: [],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        // { value: "非会员", label: 0, point: "", levelName: "非会员" },
        // { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        // { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        // { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        // { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        // { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      quantityBalance: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft:false
    };
  },
  mounted() {
    this.getLevel();
		this.fileList = [
			{
				url: "https://jdminiapp.yucrm.cn/html/images/Preview/red_lptp.png",
				name: "积分兑换红包",
			},
		];
		this.form.logo = "https://jdminiapp.yucrm.cn/html/images/Preview/red_lptp.png";
    this.init();
    this.allSearch()
    if(!this.valueRow){
      this.form.startTime = this.$getDate(30)[0]
      this.form.endTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  methods: {
    upodata(){
      this.$forceUpdate()
    },
    // 复制回显
    getDetail(){
      inquireActivity(this.valueRow.id).then(res=>{
        if(res.data.ruleDTO) {
          this.ruleDTO = res.data.ruleDTO;
        }
        this.form = res.data
        this.form.activityName = res.data.activityName
        this.$set(this.form,'redPrice',res.data.price)
        // 兼容草稿箱
        this.form.exchangeTimes = res.data.exchangeTimes == -1?"":res.data.exchangeTimes
        this.form.quantityTotal = this.form.quantityTotal?this.form.quantityTotal:null
        this.form.effectiveDays = this.form.effectiveDays?this.form.effectiveDays:null
        this.form.startTime = res.data.startTime?res.data.startTime:null;
        this.form.endTime = res.data.endTime?res.data.endTime:null;
        this.isKeyActivity = res.data.isKeyActivity||0
        this.placementPosition = res.data.placementPosition?res.data.placementPosition.split(','):["SHOP"]
        this.activityTimeChange();
        if(!this.activityData.isCopy){
          const checkedLevel = res.data.memberLevelPointsDTOList.filter(item=>item.allow).map(item=>item.level)
          let allLevel = true
          let isAll = true
          this.memberLevelList.forEach(list=>{
            if(!checkedLevel.includes(list.value)){
              allLevel = false
            }
          })
          res.data.memberLevelPointsDTOList.forEach(item=>{
            if(item.allow){
              if(item.point != res.data.memberLevelPointsDTOList[0].point){
                isAll = false
              }
            }
          })
          // 全部会员
          if(allLevel){
            this.memberLe = true
            this.level = this.memberLevelList.map(item=>item.value)
          }else{
            this.memberLe = false
            this.level = checkedLevel
          }
          // 统一设置
          if(isAll){
            this.isLevelSet = false
            this.form.memberLevelPoints = res.data.memberLevelPointsDTOList[0].point
          }else{
            this.isLevelSet = true
            this.memberLevelList.forEach(item=>{
              res.data.memberLevelPointsDTOList.forEach(list=>{
                if(item.value == list.level && list.allow){
                  item.point = list.point
                }
              })
            })
          }
        }
        if(this.activityData.isCopy){
          //规则
          this.form.ruleDescription = ""
        }
      })
    },
    init() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "38",
          openMerchant: "",
          openType: 0,
          imageName: "积分兑换红包",
          templateUrl: "https://jdminiapp.yucrm.cn/html/images/Preview/dhhb2.png",
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getCodeIMG() {
      // const data = await prefixurl();
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = `${this.activityData.telCode}/clientPreview?activityType=${this.activityData.id}&venderId=${data.data.venderId}`;
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
      this.$nextTick(() => {
        this.$refs.upload.$children[1].$el.style.display = "none";
      });
    },
		// 限制大于等于0正数，带两个小数点
    handelInput(dataName,max = -1) {
      let inputValue = this.form[`${dataName}`];

      // 除数字和小数点之外
      inputValue = inputValue.replace(/^\d[0,9]\.[0-9]{2}?$/, "");

      // 限制小数点后两位
      const parts = inputValue.split(".");
      if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
        parts[0] = parts[0].substring(1);
      }
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        inputValue = parts[0] + "." + parts[1];
      } else {
        inputValue = parts[0];
      }

      let value = isNaN(inputValue) ? "" : inputValue.toString();

      if (max != -1 && max < value) {
        value = max;
      }
			
      // 更新数据
      this.form[`${dataName}`] = value;
      this.$forceUpdate();
    },
    //判断输入最小值
    changeInput(dataName,min) {
      let inputValue = this.form[`${dataName}`];
      console.log("inputValue最小值",inputValue)
      if(Number(inputValue) && Number(inputValue) < min){
        this.$message({
          message: "最小值为0.1",
          type: "warning",
        });
        // 更新数据
        this.form[`${dataName}`] = min;
        this.$forceUpdate();
      }

    },
    // 套餐内发行总量自动计算
    setQuantityTotal() {
      this.form.quantityTotal = 0;
      this.form.exchangeSet.forEach((e) => {
        if (e.singleNum && e.total) {
          this.form.quantityTotal += e.singleNum * e.total;
        }
      });
    },
    onShowAddCoupon() {
      if (this.venderType == true) {
        this.selfSupportAddCouponIsShow = true;
      } else {
        this.addCouponIsShow = true;
      }
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = { value: item.customerLevel, label: item.customerLevelName, point: ""};
          return obj
        });
        // 默认全部选中
        this.level = res.data.map(item=>item.customerLevel)
        // 复制、草稿编辑
        if(this.valueRow && this.valueRow.id){
          this.isCopy = this.activityData.isCopy
          this.getDetail()
        }
      })
    },
    //输入框限制负数
    checkputn0(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
    },
    //输入框限制负数
    checkputn1(e, num = -1) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      if (num != -1 && e.target.value > num) {
        e.target.value = "";
      }
    },
    inputNum(e){
      console.log(e,this.form.redPrice)
      if(Number(e) < 1){
        this.$message.warning("最小面额为1");
        this.form.redPrice = ''
      }
    },
    //返回
    retrunMethod() {
      if(this.isCopy && this.localStep != 0) return this.localStep = 0;
      this.form.activityName = "";
      this.form.logo = "";
      this.form.activityName = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      this.form.startTime = "";
      this.form.endTime = "";
      this.level = [1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      // this.$emit("returnback");
      if (this.localStep == 0) this.$emit("returnback");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.form.endTime = null;
        return;
      }
      if (start < nowTime) {
        // this.$message.warning("开始时间不能小于当前时间");
        // this.form.startTime = null;
        // return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    //活动时间驱动
    activityTimeChange2(val) {
      // 校验有无时间
      if(!this.form.endTime || !this.form.startTime)return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.cashStartTime).valueOf();
      let end = new Date(this.form.cashEndTime).valueOf();
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.cashEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.cashEndTime = null;
        return;
      }
    },
    // 隐藏添加优惠券组件
    addCouponChange() {
      this.addCouponIsShow = false;
      // console.log(111);
    },
    //取消优惠券
    createActivity() {
      let couponId = this.couponId;
      closeSellerCouponWrite(couponId)
        .then((res) => {
          if (res && res.code == 1) {
            this.butActive = 1;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map(item=>item.value)
      } else {
        this.level = [];
      }
    },

    checkTheChange(val) {
      if (val.length == 5) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    //获取优惠券信息
    addStatus(val) {
      this.butActive = 2;
      this.couponId = Number(val);
      querydetail(this.couponId)
        .then((res) => {
          this.couponTxt = res.data;
          let sum1 = res.data.beginTime.split(" ");
          let sum2 = res.data.endTime.split(" ");
          this.couponTxt.beginTime = sum1[0];
          this.couponTxt.endTime = sum2[0];
          // console.log(res);
        })
        .catch((res) => {});
    },

    //自营店铺获取优惠券信息
    addStatusCoupon(data) {
      console.log("data", data);
      this.butActive = 2;
      this.couponTxt = data;
      let sum1 = data.startTime.split(" ");
      let sum2 = data.endTime.split(" ");
      this.couponTxt.startTime = sum1[0];
      this.couponTxt.endTime = sum2[0];
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getShopList();
      this.getSeller();
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalList = res.data.total;
        // console.log(res, 1111111111);
      });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择
    chooseShop(val) {
      console.log(val);
      this.form.activityName = val.skuName.substr(0, 15);
      this.form.price = val.jdPrice;
      this.form.wareId = val.categoryId;
      this.form.logo = val.logo;
      this.dialogFormVisible = false;
    },
    searchContent(val) {
      // console.log(val, 2222);
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      // this.formShopList.cascaderArr = val.cascaderArr;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 1.5;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 生成规则
    generativerule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";

      let tabName = "份红包";
      //活动名称
      if (this.form.startTime && this.form.endTime) {
        text1 = `活动时间：${this.form.startTime} 至 ${this.form.endTime}`;
      }
      if (this.form.exchangeDayTimes || this.form.exchangeTimes) {
        text2 = `兑换次数限制：${this.form.exchangeDayTimes ? "每人每日可兑换" + this.form.exchangeDayTimes + "次红包" : ""}${
          this.form.exchangeTimes ? `${this.form.exchangeTimes ? "," : ""}每人活动期间可兑换` + this.form.exchangeTimes + "次红包" : ""
        }`;
      }
      if (this.form.exchangeDayNum || this.form.exchangeNum) {
        text3 = `兑换数量限制：${this.form.exchangeDayNum ? "每人每日可兑换" + this.form.exchangeDayNum + "份红包" : ""}${
          this.form.exchangeNum ? `${this.form.exchangeDayNum ? "," : ""}每人活动期间可兑换` + this.form.exchangeNum + "份红包" : ""
        }`;
      }
      this.level.sort();
      if (this.memberLe) {
        text4 = "兑换所需等级：全部会员";
      } else {
        let levelStr = [];
        this.memberLevelList.forEach((item) => {
          if(this.level.includes(item.value)){
            levelStr.push(item.label)
          }
        });
        text4 = "兑换所需等级：" + levelStr.splice(",");
      }
      if (this.isLevelSet) {
        let levelText = [];
        this.level.forEach((item, index) => {
          this.memberLevelList.forEach((it, index) => {
            if (item == it.value) {
              let str = it.label + it.point + "积分=1" + tabName;
              levelText.push(str);
            }
          });
        });
        text5 = "兑换消耗积分:" + levelText.splice(",");
      } else {
        text5 = "兑换消耗积分:" + this.form.memberLevelPoints + "积分=1" + tabName;
      }
      text6 = "奖品数量有限，先到先得，如果积分用于兑换奖品后，不予退回";
      text7 = "奖品会自动发放到你账户，如有疑问请联系在线客服";
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      this.form.ruleDescription = newText;
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },

    clearTime2() {
      this.form.cashStartTime = "";
      this.form.cashEndTime = "";
    },

    jumpRC() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 查询资产账户余额
    allSearch() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      allAccount({ type: 8 }).then((res) => {
        res.data.forEach((item) => {
          sum += item.quantityBalance;
        });
        res.data.forEach((item) => {
          sum2 += item.quantityTotal;
        });
        res.data.forEach((item) => {
          sum3 += item.quantityFrozen;
        });
        this.quantityBalance = sum;
        this.quantityTotal = sum2;
        this.quantityFrozen = sum3;
      });
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //创建礼品兑换活动
    async setActivity() {
      //活动创建限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      // 活动对象校验
      await this.$refs.information.verify()
      if (!this.form.startTime || !this.form.endTime) {
        this.$message.warning("请输入上下架时间");
        return;
      }
      if (!this.form.logo) {
        this.$message.warning("请添加礼品图片");
        return;
      }

      if (!this.form.exchangeDayTimes) {
        this.$message.warning("请填写每人每日兑换次数");
        return;
      }

      if (!this.form.exchangeTimes) {
        this.$message.warning("请填写每人活动内兑换次数");
        return;
      }

      if (!this.form.exchangeDayNum) {
        this.$message.warning("请填写每人每日兑换份数");
        return;
      }

      if (!this.form.exchangeNum) {
        this.$message.warning("请填写每人活动内兑换份数");
        return;
      }

      //红包有效期
      if(this.form.redPacketExpiration == 2){
        //相对时间
        if(!this.form.effectiveDays){
          this.$message.warning("请填写红包有效期");
        }
      }else if(this.form.redPacketExpiration == 1){
        //绝对时间
        if(!this.form.effectiveEndTime){
          this.$message.warning("请填写红包有效期");
        }
      }

      if (!this.form.redPrice) {
        this.$message.warning("请填写单份红包金额");
        return;
      }


      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }


      if (!this.form.quantityTotal) {
        this.$message.warning("请输入发行总量!");
        return;
      }
      if (this.level.length == 0) {
        this.$message.warning("请输入兑换所需等级");
        return;
      }
      // 兑换所需积分校验
      if(this.isLevelSet){
        let flag = false
        this.memberLevelList.forEach(list=>{
          if(!list.point){
            flag = true
          }
        })
        if(flag)return this.$message.warning("请输入兑换所需积分");
      }else{
        if (!this.form.memberLevelPoints) {
          this.$message.warning("请输入兑换所需积分");
          return;
        }
      }
      if (!this.form.ruleDescription) {
        this.$message.warning("请输入规则说明");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.showSetDialog = true;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    handleDialogCloseAnoth(){
      let copyForm = JSON.parse(JSON.stringify(this.form));
      if(this.checked || this.isDraft){
        let obj = {
          activityName: this.form.activityName,
          activityType: 38,
          endTime: this.form.endTime,
          exchangeTimes: "",
          logo: this.form.logo,
          memberLevelPointsDTOList: [],
          price:this.form.redPrice,
          quantityTotal: this.form.quantityTotal,
          ruleDescription: this.form.ruleDescription,
          startTime: this.form.startTime,
          ruleType: this.form.frequencyType,
          exchangeDayTimes:this.form.exchangeDayTimes,
          exchangeTimes:this.form.exchangeTimes,
          exchangeNum:this.form.exchangeNum,
          exchangeDayNum:this.form.exchangeDayNum,
          redPacketExpiration:this.form.redPacketExpiration,
          effectiveDays:Number(this.form.effectiveDays),
          isKeyActivity:this.isKeyActivity,
          placementPosition:this.placementPosition.join(','),
        };
        obj.ruleDTO = this.ruleDTO;
        if(this.form.redPacketExpiration == 1){
          obj.effectiveStartTime=this.form.startTime
          obj.effectiveEndTime=this.form.effectiveEndTime
        }
        // 处理兑换所需积分
        obj.memberLevelPointsDTOList = this.memberLevelList.map(item=>{
          const checked = this.level.includes(item.value)
          return {
            allow:checked,
            level:item.value,
            levelName:item.label,
            point:checked?this.isLevelSet?item.point:this.form.memberLevelPoints:0
          }
        })

        obj.activityName = this.form.activityName;
        obj.activityType = this.tabActive;
        obj.quantityTotal = this.form.quantityTotal?Number(this.form.quantityTotal):null;
        if(this.isDraft){
          obj.status = 5
        }
        // 草稿箱编辑-添加活动id
        if(this.isDraftEdit){
          obj.id = this.valueRow.id
        }
        if(this.activityData&&this.activityData.singleCopy){
          delete obj.id
        }
        createRedPacket(obj).then((res) => {
          if (res && res.code == 1) {
            if(this.isDraft){
              this.$emit("returnback",true);
            }else{
              this.memberLevelPointsDTOList = [];
              this.$message.success(res.message);
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });

      }else {
        this.$message.error("请勾选明确活动规则后即可创建");
      } 
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      fn;
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.level-wrap{
  display: flex;
  /deep/.el-checkbox-group{
    margin-right: 16px;
  }
}
.firststep {
  min-height: 820px;
  box-sizing: border-box;
  padding: 0px 35px 25px;
}
.create_coupons {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // min-height: 880px;
  margin: -24px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 0px 0 0 24px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #7b61ff;
      color: #7b61ff;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 280px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        margin-left: 10px;
        // margin-left: 20px;
        border: 1px solid #7b61ff;
        color: #7b61ff;

        background: rgba(123, 97, 255, 0.1);
        font-size: 13px;
        &:hover {
          background-color: #7b61ff;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #7f85e9;
      background: rgba(127, 133, 233, 0.1);
      color: #7f85e9;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    line-height: 32px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
</style>
